import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { NAV_BRAND } from '../../config'
import { PORTAL_TYPE_YF } from '../../config/constants'
import { JOB_THEMES } from '../../page/constants'
import { getPageType } from '../../page/store/selectors'
import PropTypesHelpers from '../../utils/propTypesHelpers'

import CharLogo from './CharLogo'
import KununuScoreWidget from './KununuScoreWidget'

const mobileLogoSize = {
  default: { width: 75, height: 35 },
  [PORTAL_TYPE_YF]: { width: 90, height: 40 }
}

export const ImgRow = ({ children, className, kununu, withKununuScore = true, ...props }) => {
  const pageType = useSelector(getPageType)
  const showKununu = !JOB_THEMES.includes(pageType) && kununu?.score

  const { width: mobileWidth, height: mobileHeight } = useMemo(() => {
    return mobileLogoSize[NAV_BRAND.portal_type] || mobileLogoSize.default
  }, [])

  return (
    <div className={classnames('img-row', {
      'with-kununu-score': withKununuScore && !!kununu?.score
    })}
    >
      <div className='img-logo-section'>
        {showKununu && withKununuScore && <KununuScoreWidget score={kununu.score} />}
        <div className='img-container'>
          {props.src &&
            <img className={`${className || 'img'} img--lg`} {...props} width='100' height='45' loading='lazy' />}
          {props.src &&
            <img className={`${className || 'img'} img--sm`} {...props} width={mobileWidth} height={mobileHeight} loading='lazy' />}
          {!props.src &&
            <CharLogo name={props.alt} />}
        </div>
      </div>
      <div className='img-row-content'>
        {children}
      </div>
    </div>
  )
}

ImgRow.propTypes = {
  children: PropTypesHelpers.children,
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  kununu: PropTypes.shape({
    score: PropTypes.number
  }),
  withKununuScore: PropTypes.bool,
  className: PropTypes.string
}

export default ImgRow
